import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

function useInjectionDetection(): void {
  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLScriptElement) {
            const scriptContent = node.src || node.textContent || 'Unknown script content';
            const warningMessage = 'Unexpected script injected';

            console.warn(warningMessage, scriptContent);
            //** Removing for now as it is causing a lot of noise - Will implement again at a later date */
            // Sentry.captureEvent({
            //   message: warningMessage,
            //   level: "warning",
            //   extra: { scriptContent },
            // });
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);
}

export default useInjectionDetection;
